import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType} from "./nbinput.entity";

@Component({
  selector: 'nbinput-label',
  template: require('./nbinput-label.component.html'),
  styles: [require('./nbinput-image.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputLabelComponent),
      multi: true
    }
  ]
})

export class NbinputLabelComponent implements ControlValueAccessor {
  public FieldType = NbFieldType;
  registerOnChange(fn: any): void {/* label不支持用户手动修改值 */}
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {/* label没有禁用与否的区别 */}
  writeValue(obj: string): void {
    setTimeout(()=> {
      this.data = obj;
    }, 0);
  }
  @Input()
  readonly:boolean;
  @Input()
  data;
  @Input()
  type:NbFieldType = NbFieldType.Text;
  public _options:OptionDef[];
  @Input()
  set options(o:OptionDef[]){
    if ((this.type == NbFieldType.Multiple ||
        this.type == NbFieldType.Massive ||
        this.type == NbFieldType.Option) && o){
      this.data = o.filter(e => e.value == this.data).map(e => e.text).join(',');
    }
  }

  constructor(
  ) {}
}
export class OptionDef{
  text: string; // 更新字段的option文本
  value: string; // 更新字段的option值
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-label.component.ts